import { Action } from '@/components/sections/Card';
import { Product } from '@/services/api/contracts/catalog/types';

import { useBundlesWithProduct } from '@/services/bundles/useProductInBundles';
import { useIsProductSelected, useSelectProduct } from '@/services/catalogue/useCustomerCatalogueService';
import { FunctionComponent } from 'react';
import { FiX } from 'react-icons/fi';
import { twMerge } from 'tailwind-merge';

interface ToggleSelectedProductActionProps {
  openUnselectProductErrorModal: () => void;
  product: Product;
}

const ToggleSelectedProductAction: FunctionComponent<ToggleSelectedProductActionProps> = ({
  openUnselectProductErrorModal,
  product
}) => {
  const isProductSelected = useIsProductSelected(product);
  const bundlesWithProduct = useBundlesWithProduct(product.id);
  const toggleSelected = useSelectProduct(product);

  const onToggleSelected = () => {
    if (isProductSelected && bundlesWithProduct.length > 0) {
      openUnselectProductErrorModal();
      return;
    }

    toggleSelected();
  };

  return (
    <Action onClick={onToggleSelected} className="flex w-full items-center justify-center gap-1 p-2 text-sm">
      <div className={twMerge('font-medium flex items-center gap-1', isProductSelected ? 'text-red-500' : '')}>
        {isProductSelected && <FiX />}
        <span>{isProductSelected ? 'Remove from selected' : 'Select Product'}</span>
      </div>
    </Action>
  );
};

export default ToggleSelectedProductAction;
